import { unsafeCoerce } from 'fp-ts/lib/function';
import { addQueryParams } from '../common/routing/addQueryParams';
import { env } from '../common/util/env';
import { FormState } from './FormState/FormState';
import { BookingFormClient } from './util/useDisplayAppointment';

export const PRIVACY_SUMMARY_URL =
  'https://privacy.healthengine.com.au/booking_privacy_panel_telehealth/';

export const PRIVACY_SUMMARY_URL_CBP =
  'https://healthengine.com.au/legal/commonwealth/privacy-summary';

export const PRIVACY_HOME_PAGE_URL = 'https://privacy.healthengine.com.au/';

export const EMERGENCY_CALL_NUMBER = '000';

export const EMERGENCY_LIFELINE_NUMBER = '13 11 14';

export const TERMS_URL = 'https://healthengine.com.au/terms.php';

export const PRIVACY_POLICY_URL = 'https://healthengine.com.au/privacy.php';

export const COLLECTION_NOTICE_URL = 'https://healthengine.com.au/collection.php';

export const makeBookingUrlFromFormState = (formstate: FormState, additionalPath?: string) =>
  makeBookingUrl(
    unsafeCoerce(formstate.appointment.bookingFormClient),
    unsafeCoerce(formstate.appointment.practice?.id),
    unsafeCoerce(formstate.appointment.specialty),
    formstate.appointment.dateString,
    additionalPath,
  );

export const makeBookingUrl = (
  bookingFormClient: BookingFormClient,
  practiceId: string,
  specialty: string,
  datetime?: string,
  additionalPath: string = '',
) => {
  // on development use a hostname, on production this will be a relative path
  const host = process.env.NODE_ENV === 'development' ? env.MEGATRON_HOST : '';

  if (datetime) {
    return `${host}/appointment/${bookingFormClient}/${practiceId}/${specialty}/${datetime}/${additionalPath}`;
  }

  return `${host}/appointment/${bookingFormClient}/${practiceId}/${specialty}/${additionalPath}`;
};

// Add an additional query param to success urls to indicate new booking form
export const successUrl = (url: string, params: Record<string, string>) => {
  params['nbf'] = 'true';

  return addQueryParams(url, params);
};

// Stolen from black-hat repo
export const makeScriptsUrl = (practiceId: string, apptDoctorId?: string) =>
  `/scripts/prescriptions/${practiceId}/${apptDoctorId ? `?doctor=${apptDoctorId}` : ''}`;
